import { createFileRoute } from '@tanstack/react-router'

import { OrganisationsScreen } from '@/features/platform-orgs/organisations-screen'
import { organisationsSearchSchema } from '@/features/platform-orgs/organisations-search'

/** Every dealership on the platform: the status tab, search, state, sort and page in the address. */
export const Route = createFileRoute('/_app/platform/organisations/')({
  validateSearch: organisationsSearchSchema,
  component: OrganisationsScreen,
})
